module.exports = __webpack_public_path__ + "b4a3acef6dbac25f35f72cd5cc0c6d2e.jpg";